import { DescriptionsProps, Grid } from "antd";
import { CustomDescriptions } from "./index.styled";

/**
 * 반응형 description
 * @param param0
 * @returns
 */
export const ItemDescriptions: React.FC<DescriptionsProps> = ({ ...props }) => {
  const screen = Grid.useBreakpoint();

  return (
    <CustomDescriptions
      layout={screen.xs ? "vertical" : "horizontal"}
      colon={false}
      column={1}
      bordered={false}
      labelStyle={{
        width: 180,
        fontWeight: 500,
      }}
      {...props}
    />
  );
};
